@if (error) {
<span class="flex items-center gap-1 mt-2">
  <i class="pi pi-fw pi-exclamation-circle text-red-500"></i>
  <small class="text-red-500">{{ error }}</small>
</span>
}
